/* eslint-disable jira/filename-case */
// eslint-disable-next-line jira/restricted/react-intl
// eslint-disable-next-line jira/restricted/react-intl
// eslint-disable-next-line jira/restricted/react-intl
import { createIntl, createIntlCache, type IntlConfig, type IntlShape } from 'react-intl';

const cache = createIntlCache();

export const getIntl = (config: IntlConfig): IntlShape => createIntl(config, cache);
